import { Component, AfterViewInit, OnChanges, SimpleChanges, OnDestroy, Input, Output, EventEmitter, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Jodit } from 'jodit';

type JoditConfig = Parameters<typeof Jodit.make>[1];

@Component({
  selector: 'jodit-editor',
  templateUrl: './jodit-editor.component.html',
  styleUrls: ['./jodit-editor.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class JoditEditorComponent implements AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('editor', { static: true }) editorRef!: ElementRef;

  @Input() config: JoditConfig = {};
  @Input() content: string = '';

  @Output() contentChange = new EventEmitter<string>();
  @Output() ready = new EventEmitter<Jodit>();

  private joditInstance!: Jodit;

  ngAfterViewInit() {
    this.initializeEditor();
  }

  // Handle changes to input properties, including the initial load
  ngOnChanges(changes: SimpleChanges) {
    this.initializeEditor();
    if (changes['content'] && this.joditInstance) {
      this.joditInstance.value = changes['content'].currentValue;
    }
  }

  ngOnDestroy() {
    if (this.joditInstance) {
      this.joditInstance.destruct();
    }
  }

  private initializeEditor(): void {
    if (!this.joditInstance) {
      this.joditInstance = Jodit.make(this.editorRef.nativeElement, this.config);

      // The 'change' event listener gives us the new value
      this.joditInstance.events.on('change', (value: string) => {
        this.contentChange.emit(value);
      });
      this.ready.emit(this.joditInstance);
    }
  }
}
